import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { FaqList } from "@/components/common/FaqList";

export const FaqPreview = () => {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/faqs").then((r) => {
      const home = r.data.filter((f) => f.show_on_home);
      setFaqs((home.length ? home : r.data.filter((f) => f.category === "clinic")).slice(0, 3));
    }).catch(() => setFaqs([]));
  }, []);
  if (!faqs.length) return null;
  return (
    <section className="section bg-brand-tint" aria-labelledby="faq-preview-heading">
      <div className="container-x grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">Questions</p>
          <h2 id="faq-preview-heading" className="font-heading text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">Frequently asked questions</h2>
          <Link to="/faq" className="text-link mt-6" data-testid="faq-preview-all-link">See all FAQs <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
        </div>
        <div className="lg:col-span-8"><FaqList faqs={faqs} prefix="home-faq" /></div>
      </div>
    </section>
  );
};
